import { memo } from 'react';
import QuestionViewer from '../QuestionViewer';
import TagChoiceEditor, { TagChoiceViewer } from './MultiChoiceFields';
import {
  IMultipleChoiceQuestionView,
  ISurveyItem,
  ISurveyView,
  QuestionState,
} from 'store/survey/surveyTypes';
import { ICompany } from 'store/companies/companiesTypes';
import { appDispatch } from '../../../../../../store/store';
import { IQuestionViewerProp } from '../GeneralQuestion/GeneralQuestionViewer';

interface IComponentProps extends IQuestionViewerProp {
  question: { data: IMultipleChoiceQuestionView; state: QuestionState };
  secondaryQuestion: {
    data: IMultipleChoiceQuestionView;
    state: QuestionState;
  };
  secondaryProviderSurvey: ISurveyItem;
  company?: ICompany;
  survey?: ISurveyView;
}

const MultiChoiceQuestionViewer: React.FC<IComponentProps> = ({
  tags,
  index,
  surveyId,
  question,
  secondaryProviderSurvey,
  secondaryQuestion,
  displayDeleted,
  providerSurvey,
  readOnly,
  company,
  survey,
  ...otherProps
}) => {
  const {
    data: { useTags, choiceList, viewMode },
  } = question;

  return (
    <QuestionViewer
      icon="check"
      tags={tags}
      index={index}
      dispatch={appDispatch}
      surveyId={surveyId}
      question={question}
      secondaryProviderSurvey={secondaryProviderSurvey}
      secondaryQuestion={secondaryQuestion}
      displayDeleted={displayDeleted}
      providerSurvey={providerSurvey}
      readOnly={readOnly}
      child={(editing: boolean) =>
        !editing ? (
          <TagChoiceViewer
            useTags={useTags}
            viewMode={viewMode}
            choiceList={choiceList}
            survey={survey}
            tags={tags}
            question={question}
          />
        ) : (
          <TagChoiceEditor
            tags={tags}
            questionId={question.data.id}
            company={company}
            showSecondary={!!secondaryQuestion}
            survey={survey}
          />
        )
      }
      {...otherProps}
    />
  );
};

export default memo(
  MultiChoiceQuestionViewer,
  (prevProps: IComponentProps, nextProps: IComponentProps) => {
    return (
      prevProps.question === nextProps.question &&
      prevProps.index === nextProps.index &&
      prevProps.secondaryQuestion === nextProps.secondaryQuestion &&
      prevProps.questionState === nextProps.questionState
    );
  }
);
